import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { generateRandomString } from "../../../utils/helper";
import { setIsLoading } from "../../payroll/slices/payrollSlice";
import * as templateServices from "../services/notificationTemplateApi"
import useWelfare from "./useDropdownTemplate";
import { getNotificationTemplateById, updateNotificationTemplateById } from "../services/notificationTemplateApi";
import { setTemplateData } from "../slices/templateSlice"
import * as services from "../../newAndPolicy/services/newsApi";
import alert from "../../../components/elements/Alert";
import { Modal } from "antd";


function useNotificationTemplateList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const isLoading = useSelector((state) => state.news.isLoading);
    const currentNews = useSelector((state) => state.news.currentNews);
    // const [templateData, setTemplateData] = useState({});
    const currentApprover = useSelector((state) => state.company.currentEmployee);
    const currentEmployee = useSelector((state) => state.company.currentEmployee);

    // console.log("templateData",templateData)
    const getTemplateData = useCallback(
        async (id) => {

            try {
                dispatch(setIsLoading(true));

                if (id) {
                    const values = {
                        emailTemplateId: id,
                        requestId: generateRandomString(),
                        companyId: currentCompany,
                        employeeId: currentApprover,
                        actionId: currentEmployee,

                    };
                    const response = await templateServices.getNotificationTemplateById(values);
                    dispatch(setTemplateData(response.data));
                    console.log("templateData", response.data);
                }

            } catch (error) {


                alert({ type: "error", resultObject: error });
                console.log("Bad", error);
                // console.log(templateData);

            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch]
    );

    const editTemplateData = useCallback(
        async (values) => {
            try {
                dispatch(setIsLoading(true));
                const result = await templateServices.updateNotificationTemplateById((values));
                alert({ resultObject: result });
                navigate("/configuration/notification_template");
            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch, navigate]
    );


    useEffect(() => {
        if (typeof currentCompany !== "object") {
            getTemplateData();
        }
    }, [currentCompany, getTemplateData]);


    const onSubmit = useCallback(
        (values) => {
            console.log("submit", values);
            const modifiedValues = {
                ...values,
                emailTemplateId: values.id,
                requestId: generateRandomString(),
                employeeId: currentApprover,
                actionId: currentEmployee,
                companyId: currentCompany,
            };
            Modal.confirm({
                title: "Confirmation",
                content: (
                    <>
                        <p>
                            Are you sure confirm to{" "}
                            {values.id ? "edit" : "create"}  ?
                        </p>
                    </>
                ),
                onOk() {
                    if (values.id) {
                        editTemplateData(modifiedValues);
                    }
                },
                okText: "CONFIRM",
                cancelText: "CANCEL",
            });
        },
        [currentCompany, editTemplateData]
    );



    return {
        // templateData,
        getTemplateData,
        onSubmit
    }



}


export default useNotificationTemplateList;